/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

angular.module("uCountitUiApp").config(($stateProvider) =>
  $stateProvider.state("app.sitemap", {
    url: "/sitemap/:id",
    templateUrl: "app/sitemap/sitemap.html",
    controller: "SitemapCtrl",
  })
)
